var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","total":_vm.total,"current-page":_vm.page,"page-size":_vm.limit},on:{"current-change":_vm.handlePageChange,"size-change":_vm.handleSizeChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }